export default {"src":"/_next/static/media/tocBackground.3931128e.svg","height":571,"width":274};